import { useEffect, useState } from "react";
import { Combobox, InputBase, useCombobox } from "@mantine/core";

export function SearchableSelect({ data, value, setValue }) {
  const combobox = useCombobox({
    onDropdownClose: () => combobox.resetSelectedOption(),
  });

  const [search, setSearch] = useState("");
  useEffect(() => {
    // value can legitimately go back to "" (e.g. selecting an entity with no
    // sensor) — the display must clear too, not keep the previous text
    setSearch(value || "");
  }, [value]);

  const shouldFilterOptions = data.every((item) => item !== search);
  const filteredOptions = shouldFilterOptions
    ? data.filter((item) =>
        item.toLowerCase().includes(search.toLowerCase().trim())
      )
    : data;

  const options = filteredOptions.map((item) => (
    <Combobox.Option value={item} key={item} className="!p-0">
      <div
        className={`${
          item === search ? "bg-grayText4 rounded-sm" : ""
        } px-1 py-1`}
      >
        {item}
      </div>
    </Combobox.Option>
  ));

  return (
    <Combobox
      store={combobox}
      withinPortal={false}
      onOptionSubmit={(val) => {
        value === val ? setSearch("") : setSearch(val);
        value === val ? setValue("") : setValue(val);
        combobox.closeDropdown();
      }}
      disabled={data.length === 0}
    >
      <Combobox.Target>
        <InputBase
          rightSection={<Combobox.Chevron />}
          value={search}
          onChange={(event) => {
            combobox.openDropdown();
            combobox.updateSelectedOptionIndex();
            setSearch(event.currentTarget.value);
          }}
          onClick={() => combobox.openDropdown()}
          onFocus={() => combobox.openDropdown()}
          onBlur={() => {
            combobox.closeDropdown();
            setSearch(value || "");
          }}
          placeholder="Search"
          rightSectionPointerEvents="none"
        />
      </Combobox.Target>

      <Combobox.Dropdown>
        <Combobox.Options className="!w-full">
          {options.length > 0 ? (
            options
          ) : (
            <Combobox.Empty>Nothing found</Combobox.Empty>
          )}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  );
}
